import { NumberInput, minValue, useTranslate } from 'react-admin';
import { SettingsDiscountRanges } from '@/components/global/forms/SettingsSection.jsx';

export const ContractorEditDiscountRanges = () => {
    const translate = useTranslate();

    return (
        <SettingsDiscountRanges
            InputField={NumberInput}
            limitTitle={translate('resources.contractor.labels.discountRangesTitle')}
            valueTitle={translate('resources.contractor.labels.discountRangesValueTitle')}
            limitLabelKey='resources.contractor.labels.discountLimit'
            valueLabelKey='resources.contractor.labels.discountValue'
            validate={[minValue(0)]}
            inputProps={{ min: 0 }}
        />
    );
};
